export default __webpack_public_path__ + "static/4-9380cd8f5aa23c7d741516b0f8c3a426.png";